import '.eo{font-size:1.125rem;}.ssr-plugin'
import '.ea{line-height:1.75rem;}.ssr-plugin'
import '.fs{text-decoration:none;}.ssr-plugin'
import '.g7{color:var(--primary-red);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="eo ea"
    >
      {translations.privacySubtitle}{' '}
      <a className="fs g7"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="fs g7"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
